import {
  FETCH_ORDER_ENTRY_ALLCUSTOMERS_FAILURE,
  FETCH_ORDER_ENTRY_ALLCUSTOMERS_REQUEST,
  FETCH_ORDER_ENTRY_ALLCUSTOMERS_SUCCESS,
  FETCH_ORDER_ENTRY_ALLVENDORS_FAILURE,
  FETCH_ORDER_ENTRY_ALLVENDORS_REQUEST,
  FETCH_ORDER_ENTRY_ALLVENDORS_SUCCESS,
} from "./actionTypes";

import { Customers, Vendors } from "./types";

export const fetchAllCustomersRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
    isDropdown: boolean | null;
    goLiveDate: string | null;
  }
) => ({
  type: FETCH_ORDER_ENTRY_ALLCUSTOMERS_REQUEST,
  url,
  payload,
});

export const fetchAllCustomersSuccess = (
  customers: Customers[],
  totalCount: number
) => ({
  type: FETCH_ORDER_ENTRY_ALLCUSTOMERS_SUCCESS,
  payload: { customers, totalCount },
});

export const fetchAllCustomersFailure = (error: string) => ({
  type: FETCH_ORDER_ENTRY_ALLCUSTOMERS_FAILURE,
  payload: error,
});

export const fetchAllVendorsRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
    isDropdown: boolean | null;
    goLiveDate: string | null;
  }
) => ({
  type: FETCH_ORDER_ENTRY_ALLVENDORS_REQUEST,
  url,
  payload,
});

export const fetchAllVendorsSuccess = (
  vendors: Vendors[],
  totalCount: number
) => ({
  type: FETCH_ORDER_ENTRY_ALLVENDORS_SUCCESS,
  payload: { vendors, totalCount },
});

export const fetchAllVendorsFailure = (error: string) => ({
  type: FETCH_ORDER_ENTRY_ALLVENDORS_FAILURE,
  payload: error,
});
